
export default function Problems() {
  const problems = [
    {
      icon: "ri-file-excel-line",
      title: "Planilhas confusas e desatualizadas",
      description: "Fórmulas que não funcionam, sem confiabilidade."
    },
    {
      icon: "ri-error-warning-line",
      title: "Erros em cálculos de rescisão",
      description: "Um único erro pode custar multas trabalhistas altíssimas."
    },
    {
      icon: "ri-time-line",
      title: "Horas perdidas conferindo valores",
      description: "Tempo que poderia ser investido no crescimento do seu escritório."
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Risco de pagar a mais ou a menos",
      description: "Além dos clientes reclamando da folha por imprecisão nos cálculos."
    }
  ];

  return (
    <section className="py-16 md:py-24 px-4 bg-gray-50">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-6">
            Esses <span className="bg-red-600 text-white px-4 py-2 rounded-lg">ERROS</span> estão custando seu tempo e dinheiro...
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Pare de arriscar sua imagem com cálculos manuais sem precisão
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {problems.map((problem, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 border-2 border-red-200 shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-2"
            >
              <div className="text-center">
                <div className="bg-red-100 p-4 rounded-full inline-flex mb-6">
                  <i className={`${problem.icon} text-3xl text-red-600`}></i>
                </div>
                <h3 className="text-xl font-bold mb-4 text-gray-900">{problem.title}</h3>
                <p className="text-gray-600 leading-relaxed">{problem.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Call to action */}
        <div className="text-center bg-red-50 rounded-2xl p-8 border border-red-200">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            Quantos erros custosos você já cometeu este mês?
          </h3>
          <p className="text-lg text-gray-600 mb-6">
            É hora de acabar com essa preocupação de uma vez por todas.
          </p>
          <a 
            href="https://calculadp.tiagonogueira.com.br/ponto"
            className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-xl font-bold text-lg transition-all transform hover:scale-105 whitespace-nowrap inline-block cursor-pointer"
          >
            Quero Parar de Errar Agora
          </a>
        </div>
      </div>
    </section>
  );
}
